var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "match-pitch-view",
        { "fullscreen-mode": _vm.is_full_screen },
        { football: _vm.isFootball },
      ],
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "swiper",
              rawName: "v-swiper:pitchViewSwiper",
              value: _vm.swiperOption,
              expression: "swiperOption",
              arg: "pitchViewSwiper",
            },
          ],
          ref: "pitchViewSwiper",
          on: { slideChangeTransitionStart: _vm.onSlideChange },
        },
        [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.stg_list, function (strategy) {
              return _c(
                "div",
                { key: strategy.sid, staticClass: "pitch-wrap swiper-slide" },
                [
                  _c("div", { staticClass: "pitch-head" }, [
                    _vm.is_logged && _vm.has_players_selected
                      ? _c("h3", { staticClass: "pitch-title" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.is_logged.name + "'s custom team") +
                              "\n          "
                          ),
                        ])
                      : _c("h3", { staticClass: "pitch-title" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.platform.pname) +
                              ": " +
                              _vm._s(strategy.name) +
                              "\n          "
                          ),
                        ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "resize-icon mobile",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.toggleFullScreen.apply(null, arguments)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pitch-body" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "player-row player-list-1",
                          _vm.listBySkill(4).length >= 4
                            ? "view-more-players"
                            : "",
                        ],
                      },
                      [
                        _c("h3", { staticClass: "row-title" }, [
                          _vm._v(_vm._s(_vm.printSkillName(4, "name"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "player-wrap" },
                          _vm._l(_vm.listBySkill(4), function (keeper, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: [
                                  "player-card",
                                  "no-select",
                                  _vm.homeTeamId !== +keeper.tid
                                    ? "team-two"
                                    : "",
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.onOpenPlayerPopup(keeper)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "player-img" }, [
                                  keeper.in_form
                                    ? _c("span", { staticClass: "trending" })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  keeper.is_c
                                    ? _c(
                                        "span",
                                        { staticClass: "player-icon" },
                                        [_vm._v("C")]
                                      )
                                    : keeper.is_vc
                                    ? _c(
                                        "span",
                                        { staticClass: "player-icon" },
                                        [_vm._v("VC")]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "player-info" }, [
                                  _c("span", { staticClass: "player-name" }, [
                                    _vm._v(_vm._s(keeper.pn)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "team-price" }, [
                                    _vm._v(
                                      _vm._s(keeper.tsn) +
                                        " | " +
                                        _vm._s(keeper.pr)
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          "player-row player-list-2",
                          _vm.listBySkill(1).length >= 4
                            ? "view-more-players"
                            : "",
                        ],
                      },
                      [
                        _c("h3", { staticClass: "row-title" }, [
                          _vm._v(_vm._s(_vm.printSkillName(1, "name"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "player-wrap" },
                          _vm._l(_vm.listBySkill(1), function (batsmen, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: [
                                  "player-card",
                                  "no-select",
                                  _vm.homeTeamId !== +batsmen.tid
                                    ? "team-two"
                                    : "",
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.onOpenPlayerPopup(batsmen)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "player-img" }, [
                                  batsmen.in_form
                                    ? _c("span", { staticClass: "trending" })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  batsmen.is_c
                                    ? _c(
                                        "span",
                                        { staticClass: "player-icon" },
                                        [_vm._v("C")]
                                      )
                                    : batsmen.is_vc
                                    ? _c(
                                        "span",
                                        { staticClass: "player-icon" },
                                        [_vm._v("VC")]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "player-info" }, [
                                  _c("span", { staticClass: "player-name" }, [
                                    _vm._v(_vm._s(batsmen.pn)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "team-price" }, [
                                    _vm._v(
                                      _vm._s(batsmen.tsn) +
                                        " | " +
                                        _vm._s(batsmen.pr)
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          "player-row player-list-3",
                          _vm.listBySkill(3).length >= 4
                            ? "view-more-players"
                            : "",
                        ],
                      },
                      [
                        _c("h3", { staticClass: "row-title" }, [
                          _vm._v(_vm._s(_vm.printSkillName(3, "name"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "player-wrap" },
                          _vm._l(_vm.listBySkill(3), function (ar, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: [
                                  "player-card",
                                  "no-select",
                                  _vm.homeTeamId !== +ar.tid ? "team-two" : "",
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.onOpenPlayerPopup(ar)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "player-img" }, [
                                  ar.in_form
                                    ? _c("span", { staticClass: "trending" })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  ar.is_c
                                    ? _c(
                                        "span",
                                        { staticClass: "player-icon" },
                                        [_vm._v("C")]
                                      )
                                    : ar.is_vc
                                    ? _c(
                                        "span",
                                        { staticClass: "player-icon" },
                                        [_vm._v("VC")]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "player-info" }, [
                                  _c("span", { staticClass: "player-name" }, [
                                    _vm._v(_vm._s(ar.pn)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "team-price" }, [
                                    _vm._v(
                                      _vm._s(ar.tsn) + " | " + _vm._s(ar.pr)
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(0, true),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          "player-row player-list-4",
                          _vm.listBySkill(2).length >= 4
                            ? "view-more-players"
                            : "",
                        ],
                      },
                      [
                        _c("h3", { staticClass: "row-title" }, [
                          _vm._v(_vm._s(_vm.printSkillName(2, "name"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "player-wrap" },
                          _vm._l(_vm.listBySkill(2), function (bowler, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: [
                                  "player-card",
                                  "no-select",
                                  _vm.homeTeamId !== +bowler.tid
                                    ? "team-two"
                                    : "",
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.onOpenPlayerPopup(bowler)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "player-img" }, [
                                  bowler.in_form
                                    ? _c("span", { staticClass: "trending" })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  bowler.is_c
                                    ? _c(
                                        "span",
                                        { staticClass: "player-icon" },
                                        [_vm._v("C")]
                                      )
                                    : bowler.is_vc
                                    ? _c(
                                        "span",
                                        { staticClass: "player-icon" },
                                        [_vm._v("VC")]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "player-info" }, [
                                  _c("span", { staticClass: "player-name" }, [
                                    _vm._v(_vm._s(bowler.pn)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "team-price" }, [
                                    _vm._v(
                                      _vm._s(bowler.tsn) +
                                        " | " +
                                        _vm._s(bowler.pr)
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show_arrows,
                expression: "show_arrows",
              },
            ],
            ref: "prev",
            staticClass: "slider-nav swiper-button-prev swiper-button-2-prev",
          }),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show_arrows,
                expression: "show_arrows",
              },
            ],
            ref: "next",
            staticClass: "slider-nav swiper-button-next swiper-button-2-next",
          }),
        ]
      ),
      _vm._v(" "),
      _vm.is_sharing ? _c("loader", { attrs: { text: "Sharing" } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-on-pitch" }, [
      _c("img", {
        staticClass: "mobile",
        attrs: {
          src: "/static-assets/images/cssimages/svg/site-logo-h.svg?v=1.1",
          alt: "Logo",
          width: "200",
          height: "40",
        },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "web",
        attrs: {
          src: "/static-assets/images/cssimages/svg/site-logo-h.svg?v=1.1",
          alt: "Logo",
          width: "250",
          height: "47",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }